const AJAX_URL = '/ajax.php';

function buildBody(action, fields = {}) {
  const body = new URLSearchParams();
  body.set('ajax', 'true');
  body.set('action', action);

  Object.entries(fields).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    body.set(key, typeof value === 'string' ? value : JSON.stringify(value));
  });

  return body;
}

export async function postAjax(action, fields = {}, options = {}) {
  const responseType = options.responseType || 'json';
  const response = await fetch(AJAX_URL, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: buildBody(action, fields),
  });

  if (!response.ok) {
    throw new Error(`ajax.php ${action} failed: ${response.status}`);
  }

  if (responseType === 'text' || responseType === 'html') {
    return response.text();
  }

  return response.json();
}

export function loadMtaData(type, params, options = {}) {
  return postAjax('mta-load-data', { type, params }, options);
}

export function loadChat(stopId) {
  return postAjax('mta-load-chat', { stopId }, { responseType: 'html' });
}
